import React, { Suspense, useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import { Spinner } from '@material-tailwind/react';

import { Header, Sidebar } from '../../Components';

import './layout.css';
import { useDispatch } from 'react-redux';
import { handleReset } from '../../reducers/contextSlice';

// Modern loading state with better visual feedback
const PageLoader = () => (
    <div className="flex flex-col justify-center items-center py-24">
        <Spinner className="h-8 w-8 text-primary-500" />
        <p className="mt-4 text-sm text-text-tertiary">Loading...</p>
    </div>
)

export const Layout = () => {
    const dispatch = useDispatch()

    useEffect(() => {
        const reset = async () => {
            dispatch(handleReset());
            await new Promise(resolve => setTimeout(resolve, 0));
        }
        reset()
        return () => {

        }
    }, [window.location.href.split('/').pop()])
    
    return (
        <div className='flex min-h-screen bg-background-subtle'>
            {/* Sidebar */}
            <Sidebar />
            
            {/* Main content area */}
            <main className='ml-auto flex flex-col w-full 2xl:w-[calc(100%-16rem)] min-h-screen'>
                {/* Header */}
                <Header />
                
                {/* Page content */}
                <div className='flex-1 p-6 lg:p-8'>
                    <div className='max-w-[1920px] mx-auto'>
                        <Suspense fallback={<PageLoader />}>
                            <Outlet />
                        </Suspense>
                    </div>
                </div>
            </main>
        </div >
    )
}

export default Layout
